import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Modal, Button, Form, Input, message, Typography, Popover, Image } from 'antd';
import QRCode from 'qrcode.react';
import config from '@config';
import copy from 'copy-to-clipboard';
import PopoverTip from '../../../../../common/PopoverTip';

const { Text } = Typography;

export default function QrCodeShareModal({ liveInfo, setQrCodeModalOpen, qrCodeModalOpen }) {
    const params = useParams();
    const projectId = params?.projectId || 0; // 项目id

    const [shareForm] = Form.useForm();
    const [wxacode, setWxacode] = useState('');

    // 分享
    const handleShare = record => {
        const link = record.baseVO?.jumpUrl ? `${record.baseVO?.jumpUrl.replace('web', 'h5')}?mpid=${projectId}` : '';
        shareForm.setFieldValue('h5CodeLink', link);

        const wxLink = `pages/webPage1/webPage1?url=${encodeURIComponent(link)}`;
        shareForm.setFieldValue('wxQrCode', wxLink);

        shareForm.setFieldValue('projectName', record.projectName);
        getWxCodeImage(wxLink);
    };

    // 获取小程序二维码图片
    const getWxCodeImage = async link => {
        const params = {
            env_version: window.location.origin.includes('stage-') || window.location.origin.includes('test-') ? 'trial' : 'release',
            path: link,
            width: 300,
        };
        const url = `${config.API_PREFIX}/dataengine/api/mp/getwxacode`;
        const response = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json;charset=utf-8' },
            body: JSON.stringify(params),
        });

        if (response.ok) {
            const text = await response.text();
            setWxacode(text);
        }
    };

    // 下载二维码
    const downloadQRCode = type => {
        if (type === 'h5') {
            const qrCode = document.getElementById('h5_share');
            const image = new Image();
            image.src = qrCode.toDataURL('image/png');
            const link = document.getElementById(`link_h5_share`);
            link.href = image.src;
        }
        if (type === 'wx') {
            const img = document.getElementById('wx_share');
            // 创建一个 <canvas> 元素
            const canvas = document.createElement('canvas');
            // 设置 <canvas> 的宽度和高度为图片原始的宽度和高度
            canvas.width = img.naturalWidth || img.width;
            canvas.height = img.naturalHeight || img.height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
            // 将 <canvas> 内容转换为 Base64 图片数据
            const imageData = canvas.toDataURL('image/png');
            const a = document.createElement('a');
            a.download = `${shareForm.getFieldValue('projectName')}（医项目-医会议直播小程序码）.png`;
            a.href = imageData;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }
    };

    // 复制
    const onCopy = () => {
        const h5CodeLink = shareForm.getFieldValue('h5CodeLink');
        copy(h5CodeLink);
        message.success('复制成功');
    };

    useEffect(() => {
        if (qrCodeModalOpen && liveInfo) {
            handleShare(liveInfo);
        }
    }, [qrCodeModalOpen, liveInfo]);

    return (
        <Modal title="医会议直播分享" open={qrCodeModalOpen} destroyOnHidden={true} centered width={600} mask={{ closable: false }} onCancel={() => setQrCodeModalOpen(false)} footer={null}>
            <Form form={shareForm} labelCol={{ span: 4 }} wrapperCol={{ span: 20 }}>
                <Form.Item
                    name="wxQrCode"
                    label="小程序分享"
                    className="sign-wp-setting-form"
                    help="用户扫码进入小程序-医会议直播"
                    extra={
                        <PopoverTip placement="right" content={<Image src="https://mediafiles.cn-healthcare.com/boss/popovertip/medproject_share_mpcode%402x.png" width={300}></Image>} title="示例图">
                            <Text type="warning">
                                <span style={{ verticalAlign: 'middle' }}>推荐使用小程序码制作海报分享朋友圈，预热宣传</span>
                                <i className="bi bi-question-circle-fill popover-tip-icon" style={{ verticalAlign: 'middle' }}></i>
                            </Text>
                        </PopoverTip>
                    }
                >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div className="mini_program_wrap">
                            <img id="wx_share" src={wxacode} width={150}></img>

                            {wxacode && (
                                <Button onClick={() => downloadQRCode('wx')} style={{ marginLeft: 16 }}>
                                    下载小程序码
                                </Button>
                            )}
                        </div>
                    </div>
                </Form.Item>

                <Form.Item name="qrcode" label="H5 分享" className="sign-wp-setting-form" help="用户扫码/点击链接进入H5-医会议直播">
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        {shareForm.getFieldValue('h5CodeLink') && (
                            <>
                                <div className="mini_program_wrap" style={{ display: 'flex', alignItems: 'center' }}>
                                    <QRCode id="h5_share" size={120} value={shareForm.getFieldValue('h5CodeLink')} />

                                    <Button style={{ marginLeft: 16 }}>
                                        <a download={`${shareForm.getFieldValue('projectName')}（医项目-医会议直播H5二维码）`} id={`link_h5_share`} onClick={() => downloadQRCode('h5')}>
                                            下载二维码
                                        </a>
                                    </Button>
                                </div>
                            </>
                        )}
                    </div>
                </Form.Item>

                <Form.Item name="h5CodeLink" label="H5 链接" className="sign-wp-setting-form">
                    <Input.Search placeholder="input search text" allowClear enterButton="复制" size="large" readOnly={true} onSearch={onCopy} />
                </Form.Item>
            </Form>
        </Modal>
    );
}
